import logger from '@/lib/logger';

/**
 * Ephemeral scenario drafts for the current browser session.
 * Anonymous visitors can compare scenarios without an account: drafts live in
 * sessionStorage only and are never persisted server-side. Naming, saving and
 * returning to a scenario requires an account.
 */
const KEY = 'isms_scenario_drafts';
const MAX_DRAFTS = 6;

export function readDrafts() {
  try {
    const raw = sessionStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    logger.debug('[scenarioDrafts] read failed:', err?.message || err);
    return [];
  }
}

function write(drafts) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(drafts.slice(-MAX_DRAFTS)));
  } catch (err) {
    logger.debug('[scenarioDrafts] write failed:', err?.message || err);
  }
}

export function addDraft({ name, config, tco }) {
  const draft = {
    id: `draft_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
    name,
    config,
    tco: tco || null,
    createdAt: new Date().toISOString(),
  };
  write([...readDrafts(), draft]);
  return draft;
}

export function removeDraft(id) {
  write(readDrafts().filter(d => d.id !== id));
}
